module.exports = __webpack_public_path__ + "static/media/insomnia.65592825.png";